import { FieldBuilder, FieldDefinition, LocationTypes } from '@zendra/shared';
import { LocationService, PropertyService } from 'cbd-proxies';
import { WoodCertificationService } from 'geographic/proxy';

FieldBuilder.setNamespace('Geographic');

export const CERTIFIEDSTANDS_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('woodCertificationId', 'Entity.WoodCertification', WoodCertificationService)
    .required()
    .display('name')
    .displayFromNested('woodCertificationName')
    .sortBy('woodCertificationName')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('locationId', 'Entity.Stand', LocationService)
    .display('name')
    .displayFromNested('locationName')
    .sortBy('locationName')
    .queryFilter({ locationTypeEntityName: LocationTypes.Stand })
    .required()
    .build(),
  FieldBuilder.foreignKey('propertyId', 'Entity.Property', PropertyService)
    .display('name')
    .displayFromNested('propertyName')
    .sortBy('propertyName')
    .readOnly()
    .build(),
  FieldBuilder
    .date('addedDate', 'Entity.WoodCertificationDetail.AddedDate')
    .required()
    .build()
];

export const CERTIFIEDSTANDS_CONFIG = {
  entityName: 'CertifiedStands',
  localizationKey: 'Geographic::WoodCertificationDetail.CertifiedStands',
  fields: CERTIFIEDSTANDS_FIELDS,
  permission: 'PlanningGeography.WoodCertificationDetails',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
